// La copia chica de una foto de `public/images/` —
// ADR-2026-10-18-las-fichas-de-la-home-y-crear-usan-miniaturas.
//
// Las fichas de la home y el abanico de Crear dibujan las fotos a 70–170 px de ancho, pero
// las fotos son las mismas que el visor de ejemplos muestra grandes (700 a 1100 px, 200 a
// 400 KB cada una). Las copias viven en `public/images/miniaturas/`, con el MISMO camino
// que el original, a 420 px de ancho (alcanza para 140 px en una pantalla 3x).
//
// Para generar la de una foto nueva (desde `project/public`):
//   ffmpeg -i images/<ruta>.jpg -vf "scale='min(420,iw)':-2" -q:v 5 images/miniaturas/<ruta>.jpg

export const miniatura = (ruta: string): string => ruta.replace(/^\/images\//, '/images/miniaturas/');
